import styled from "styled-components";

export const NewsletterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 2rem;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 1.5rem;
  }
`;

export const NewsletterTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 700;
  color: #212529;
  margin: 0 0 0.5rem 0;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
`;

export const NewsletterDescription = styled.p`
  font-size: 1rem;
  color: #6c757d;
  margin: 0 0 1.5rem 0;
  text-align: center;
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

export const FormWrapper = styled.div`
  width: 100%;
`;

// Color variables for consistent theming
export const colors = {
  primary: "#007bff",
  primaryHover: "#0056b3",
  success: "#28a745",
  successBackground: "#d4edda",
  successBorder: "#c3e6cb",
  successText: "#155724",
  error: "#dc3545",
  errorBackground: "#f8d7da",
  errorBorder: "#f5c6cb",
  errorText: "#721c24",
  text: "#212529",
  textMuted: "#6c757d",
  border: "#e1e5e9",
  background: "#ffffff",
  shadow: "rgba(0, 0, 0, 0.1)",
};

// Spacing variables
export const spacing = {
  xs: "0.25rem",
  sm: "0.5rem",
  md: "1rem",
  lg: "1.5rem",
  xl: "2rem",
  xxl: "3rem",
};

// Breakpoints
export const breakpoints = {
  mobile: "768px",
  tablet: "1024px",
  desktop: "1200px",
};

export const borderRadius = {
  small: "4px",
  medium: "8px",
  large: "12px",
};

export const transitions = {
  fast: "0.1s ease",
  medium: "0.2s ease",
  slow: "0.3s ease",
};
